import React from 'react';
import { Button, Heading, Modal, Paragraph } from '../Ant';
import { Flex } from 'antd';
import { Slash } from '../icons';
interface InformationPopupProps {
  visible: boolean;
  onClose?: () => void;
  title: string;
  subtitle?: string;
  cancelText?: string;
  confirmText?: string;
  onConfirm?: () => void;
  cancelButtonType?: 'default' | 'primary';
  confirmButtonType?: 'default' | 'primary';
}

const InformationPopup: React.FC<InformationPopupProps> = ({
  visible,
  onClose,
  title,
  subtitle,
  cancelText,
  confirmText,
  onConfirm,
  cancelButtonType = 'default',
  confirmButtonType = 'primary',
}) => {
  return (
    <Modal
      className="confirm-modal"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={370}
      closeIcon={null}
      maskClosable={false}
    >
      <Flex gap={15} vertical align="center">
        <div className="icon-container">
          <Slash />
        </div>
        <div>
          <Heading
            level={6}
            $fontsize="14px"
            $color="title"
            $mb={5}
            $weight={600}
            $lineheight="18px"
            className="ta-center"
            data-testid="information-popup-title"
          >
            {title}
          </Heading>
          {subtitle && (
            <Paragraph
              data-te
              $fontsize="12px"
              className="ta-center"
              $color="subtitle"
              $lineheight="16px"
            >
              {subtitle}
            </Paragraph>
          )}
        </div>
        <Flex vertical gap={10} className="w-full">
          {confirmText && (
            <Button
              data-testid="information-popup-confirm-button"
              type={confirmButtonType}
              block
              onClick={onConfirm}
              size="large"
            >
              {confirmText}
            </Button>
          )}
          {cancelText && (
            <Button
              data-testid="information-popup-cancel-button"
              type={cancelButtonType}
              block
              onClick={onClose}
              size="large"
            >
              {cancelText}
            </Button>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default InformationPopup;
